import React from "react";
import { NavLink } from "react-router-dom";
import { Filters } from "./Filters";
import { SocialMenu } from "./SocialMenu";
import { Copyright } from "./Copyright";
import Masonry from "react-masonry-css";
import { InView } from "./InView";
const breakpointColumnsObj = {
  default: 2,
  559: 1
};
export class Projects extends React.Component {
  componentDidMount() {
    this.reCalculateColumnCount();
    if (window) {
      window.addEventListener("resize", this.reCalculateColumnCount);
    }
  }
  componentWillReceiveProps() {
    this.reCalculateColumnCount();
  }
  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.reCalculateColumnCount);
    }
  }
  reCalculateColumnCount() {
    const windowWidth = (window && window.innerWidth) || Infinity;
    return windowWidth;
  }
  render() {
    let projectsGallery = this.props.projects;
    let project = projectsGallery
      .filter(
        project =>
          this.props.isFiltered
            ? project.acf.type === this.props.filter
            : typeof project.acf.type === "string"
      )
      .map((project, index) => {
        let src = project.acf.posterImage.sizes.medium_large;
        return (
          <NavLink
            key={index}
            style={{ transform: this.props.isLoading ? null : "scale(1)" }}
            className={"project"}
            onMouseEnter={(e, i) => this.props.mouseEnter(e, index)}
            onMouseLeave={e => this.props.mouseLeave(e)}
            onMouseMove={e => this.props.mouseMove(e)}
            to={`/${this.props.mainMenu[0].object_slug}/${project.slug}`}
          >
            {this.props.isHovered === index &&
              !this.props.isMobileDevice && (
                <div
                  style={{ left: this.props.left, top: this.props.top }}
                  className={`project-name ${index}`}
                >
                  {project.title.rendered}
                </div>
              )}
            <img src={src} alt={`studio-${index}`} />
            {this.props.isMobileDevice && (
              <InView>
                {({ isInView }) =>
                  isInView ? (
                    <div
                      ref={this.props.innerRef}
                      className={`project-name ${index}`}
                      style={{
                        top: "50%",
                        left: "0%",
                        transform: "translate(-40%, -50%)"
                      }}
                    >
                      {project.title.rendered}
                    </div>
                  ) : null
                }
              </InView>
            )}
          </NavLink>
        );
      });
    return (

     
      <div>
        <Filters
          handleFilter={this.props.handleFilter}
          filters={this.props.filters}
          isFiltered={this.props.isFiltered}
          filteredProjects={this.props.filteredProjects}
          projects={this.props.projects}
          handleCloseBtn={this.props.handleCloseBtn}
          filtersWidth={this.props.filtersWidth}
          toggleSingleFilerClass={this.props.toggleSingleFilerClass}
          singleFilerClass={this.props.singleFilerClass}
        />
        <SocialMenu />
        <Copyright />
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="project-list"
          columnClassName={
            this.reCalculateColumnCount() >= 560
              ? "project-list-column"
              : "project-list-column-mobile"
          }
        >
          {project}
        </Masonry>
      </div>
    
    );
  }
}



// WEBPACK FOOTER //
// ./src/Projects.js